import api from './api';

const treasuryService = {
  getGoldExtract: async (params = {}) => {
    const response = await api.get('/treasury/gold', { params });
    return response.data;
  },

  createGoldTransaction: async (data) => {
    const response = await api.post('/treasury/gold/transactions', data);
    return response.data;
  },

  getRealExtract: async (params = {}) => {
    const response = await api.get('/treasury/real', { params });
    return response.data;
  },

  createRealTransaction: async (data) => {
    const response = await api.post('/treasury/real/transactions', data);
    return response.data;
  },
};

export default treasuryService;
